import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ExamManagementService } from '../../../../../../Services/exam-management/exam-management.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../../../../../Services/session.service';

@Component({
  selector: 'app-exam-instance-subject-list-ca',
  templateUrl: './exam-instance-subject-list.component.html',
  styleUrls: ['./exam-instance-subject-list.component.css'],
})
export class ExamInstanceSubjectListCAComponent implements OnInit {
  @Output() Close: EventEmitter<any> = new EventEmitter<any>();
  @Input() ExamInstanceSubject: any;
  courseId: number;
  constructor(
    private route: ActivatedRoute,
    public ExamService: ExamManagementService,
    public session: SessionService
  ) {}

  ngOnInit(): void {
      this.route.queryParams.subscribe((res) => {
        this.courseId = res?.courseId;
        this.getSubjectList();
      })


  }


  getSubjectlist: any;
  subject: any;
  uncheck: boolean = false;
  getSubjectList() {

    this.ExamService.getExamSubjectList({
      LoggedInUserID: this.session.getUser(),
      ExamInstanceID: +this.courseId,
    }).subscribe(
      (i: any) => {
        this.subject = i;
        this.getSubjectlist = this.subject.Data;
        console.log(this.getSubjectlist);
        if (this.getSubjectlist != null) {
          this.getSubjectlist.map(
            (obj: { Deleted_Ind: string; checkedflag: boolean }) => {
              obj.checkedflag = false;
              return obj;
            }
          );
          //if(this.EditStudyUnitTopicflag){
          // for(let s of this.getSubjectlist){
          //   if(s.Subject_Selected_Ind=='Y')
          //   //if(s.Available_To_Include_IND=='N')
          //   {
          //     s.checkedflag=true;
          //   }
          // }
          for (let s of this.getSubjectlist) {
            for (let i of this.ExamInstanceSubject) {
              if (s.Subject_ID == i.Subject_Id) {
                if (s.Subject_Selected_Ind == 'Y' && i.Deleted_Ind == 'N') {
                  //if(s.Available_To_Include_IND=='N')
                  s.checkedflag = true;
                }
              }
            }
          }
          //}
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  Cancel() {
    this.Close.emit(1);
  }

  SelectedSubjectlist: any[] = [];
  addvalue(data: any) {
    //let UDTReason: any[] = [];
    let list: any = {};
    (list['Exam_Instance_ID'] = data.Exam_Instance_Id),
      (list['Subject_Id'] = data.Subject_ID),
      (list['Subject_Name'] = data.Subject_Name),
      (list['Exam_Instance_Subject_ID'] = null),
      (list['Minimum_Expected_Weightage'] = ''),
      (list['Maximum_Expected_Weightage'] = ''),
      (list['Lower_Difficulty_Level_Type_Code'] = ''),
      (list['Lower_Difficulty_Level_Type_Name'] = ''),
      (list['Upper_Difficulty_Level_Type_Code'] = ''),
      (list['Upper_Difficulty_Level_Type_Name'] = ''),
      (list['Include_Questions_With_Images_Ind'] = 'N'),
      (list['Multi_Part_Question_Percentage'] = ''),
      (list['Deleted_Ind'] = 'N'),
      (list['checkedflag'] = true);
    this.SelectedSubjectlist.push(list);
    console.log(this.SelectedSubjectlist);
  }
  deleteindex: any;
  eventCheck(data: any, index: number) {
    for (let item of this.getSubjectlist) {
      if (item.Subject_Name == data.value) {
        if (item.Subject_Selected_Ind == 'Y') {
          for (let i = 0; i < this.ExamInstanceSubject.length; i++) {
            if (item.Subject_ID == this.ExamInstanceSubject[i].Subject_Id) {
              //this.SelectedSubjectlist.splice(i,1);
              this.deleteindex = i;
              this.Removealertpopup();
              break;
            }
          }

          for (let i = 0; i < this.SelectedSubjectlist.length; i++) {
            if (item.Subject_ID == this.SelectedSubjectlist[i].Subject_Id) {
              this.SelectedSubjectlist.splice(i, 1);
              item.Subject_Selected_Ind = 'N';
            }
          }
        } else {
          for (let i = 0; i < this.ExamInstanceSubject.length; i++) {
            if (item.Subject_ID == this.ExamInstanceSubject[i].Subject_Id) {
              this.deleteindex = i;
              this.uncheck = true;
              break;
            }
          }
          if (this.deleteindex != null && this.deleteindex != undefined) {
            if (this.ExamInstanceSubject[this.deleteindex].Deleted_Ind == 'Y') {
              this.ExamInstanceSubject[this.deleteindex].Deleted_Ind = 'N';
            } else if (
              this.ExamInstanceSubject[this.deleteindex].Deleted_Ind == 'N'
            ) {
              this.ExamInstanceSubject[this.deleteindex].Deleted_Ind = 'Y';
            } else {
              item.Subject_Selected_Ind = 'Y';
              this.addvalue(item);
            }
          } else {
            item.Subject_Selected_Ind = 'Y';
            this.addvalue(item);
          }
        }
      }
    }
  }
  eventCheck1(data: any, index: number) {
    this.deleteindex = undefined;
    this.eventCheck(data.target, index);
  }
  Save() {
    this.SelectedSubjectlist.forEach((element) => {
      this.ExamInstanceSubject.push(element);
    });

    console.log(this.ExamInstanceSubject, 'ExamInstanceSubject');
    this.Close.emit(1);
  }
  deletealertpopup: boolean;
  Removealertpopup() {
    this.deletealertpopup = !this.deletealertpopup;
    if (!this.deletealertpopup) {
      this.getSubjectList();
    }
  }

  Remove() {
    this.ExamInstanceSubject[this.deleteindex].Deleted_Ind = 'Y';
    for (let s of this.getSubjectlist) {
      if (
        s.Subject_ID == this.ExamInstanceSubject[this.deleteindex].Subject_Id
      ) {
        s.Subject_Selected_Ind == 'N';
        s.checkedflag = false;
      }
    }
    this.Removealertpopup();
    console.log(this.ExamInstanceSubject, 'ExamInstanceSubject');
    this.uncheck = true;
  }
}
